import { Injectable } from '@angular/core';
import { StorageType } from '@enums/enums';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private getStorage(type: string): Storage {
    return type === StorageType.SESSION ? sessionStorage : localStorage;
  }

  setItem<T>(key: string, value: T, type: StorageType = StorageType.LOCAL): void {
    try {
      const store: Storage = this.getStorage(type);
      if (typeof value === 'string') {
        store.setItem(key, value);
        return;
      }
      store.setItem(key, JSON.stringify(value));
    } catch (e) {
      console.error(`Error saving "${key}" to ${type}Storage`, e);
    }
  }

  getItem<T>(key: string, type: StorageType = StorageType.LOCAL): T | null {
    const store: Storage = this.getStorage(type);
    const raw: string | null = store.getItem(key);
    if (raw === null) return null;
    try {
      return JSON.parse(raw) as T;
    } catch {
      return raw as unknown as T;
    }
  }

  removeItem(key: string, type: StorageType = StorageType.LOCAL): void {
    try {
      this.getStorage(type).removeItem(key);
    } catch (e) {
      console.error(e);
    }
  }

  clear(type: StorageType = StorageType.LOCAL): void {
    try {
      this.getStorage(type).clear();
    } catch (e) {
      console.error(e);
    }
  }
}
